export { default } from "./resetPassword";
